
<table mat-table [dataSource]="users">
    <tr mat-header-row *matHeaderRowDef="['username', 'email']"></tr>
    <tr mat-row *matRowDef="let user; columns: ['username', 'email'];"></tr>
    <ng-container matColumnDef="username">
        <th mat-header-cell *matHeaderCellDef>Username</th>
        <td mat-cell *matCellDef="let user">
            {{user.username}}
        </td>
    </ng-container>
    <ng-container matColumnDef="email">
        <th mat-header-cell *matHeaderCellDef>Email</th>
        <td mat-cell *matCellDef="let user">
            {{user.email ?? "-"}}
        </td>
    </ng-container>
</table>